import { render } from "./MergeFieldPicker.vue?vue&type=template&id=4f054216&scoped=true"
import script from "./MergeFieldPicker.vue?vue&type=script&lang=js"
export * from "./MergeFieldPicker.vue?vue&type=script&lang=js"

import "./MergeFieldPicker.vue?vue&type=style&index=0&id=4f054216&scoped=true&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f054216"]])

export default __exports__